// Router.js
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar2 from "./Header/Navbar2";
import Footer from "./Pages/Home/Footer";

// Authentication Routes
import Login from "./Authentication/Login";
import Member_Register from "./Authentication/Member_Register";
import Member_Verify from "./Authentication/Member_Verify";
import ForgetPassword from "./Authentication/ForgetPassword";
import Restpassword from "./Authentication/Restpasswoed";
import Forget_verify from "./Authentication/Forget_verify";
import Subscription from "./Subscription/Subscription";

// Pages and Dashboard Components
import Hero from "./Pages/Home/Hero";
import Detail from "./Pages/Home/Detail";
import DemoDetail from "./Pages/Home/DemoDetail";
import AddMember from "./DashboardFiles/Network/AddMember";
import EditMember from "./DashboardFiles/Network/EditMember";
import UserProfile from "./DashboardFiles/UserProfile";
import DashboardHome from "./DashboardFiles/Dashboard/DashboardHome";
import DownlineMembers from "./DashboardFiles/Network/DownlineMembers";
import GenealogyTree from "./DashboardFiles/Network/GenealogyTree";
import EInfo from "./DashboardFiles/Ewallet/EInfo";
import Payout from "./DashboardFiles/Ewallet/Payout";
import MemberLayout from "./DashboardFiles/MemberLayout";
import ArticlesByCat from "./Pages/Home/ArticlesBycat";
import ArticlesBySubCat from "./Pages/Home/ArticlesBysubcat";
import MemberSettings from "./DashboardFiles/Settings/MemberSettings";
import InviteTopline from "./Pages/Home/InviteTopline";
import SignUp from "./Pages/Home/SignUp"
import SignUpForm from "./Pages/Home/SignUpForm"
import InviteFriends from "./Pages/Home/InviteFriends"


// Admin Components
import AdminProfile from "./Admin/AdminProfile";
import AdminEditProfile from "./Admin/AdminEditProfile";
import AdminDashboardRoutes from "./Admin/AdminDashboardRoutes";
import AdminLayout from "./Admin/AdminLayout";
import AdminDashboard from "./Admin/AdminDashboard";
import QuickAccess from "./Admin/ArticleMangement/MultimediaManagement";
import ArticleManagement from "./Admin/ArticleMangement/ArticleManagement";
import RssPost from "./Admin/ArticleMangement/RssArticleManagement";
import AddRss from "./Admin/ArticleMangement/AddRssPost";
import EditRss from "./Admin/ArticleMangement/EditRssPost";
import MagazineManagement from "./Admin/ArticleMangement/MagazineMaster";
import AddMagazine from "./Admin/ArticleMangement/AddMagazine";
import EditMagazine from "./Admin/ArticleMangement/EditMagazine";
import MultimediaManagement from "./Admin/ArticleMangement/MultimediaManagement";
import UserManagement from "./Admin/MemberMangement/UserManagement";
import AdminReports from "./Admin/MemberMangement/AdminReports";
import AddPost from "./Admin/ArticleMangement/AddPost";
import EditPost from "./Admin/ArticleMangement/EditPost";
import AdManagement from "./Admin/ArticleMangement/AdManagement";
import AdminUserAdd from "./Admin/MemberMangement/AdminUserAdd";
import EditUserPage from "./Admin/MemberMangement/AdminEditUser";
import RoleManagement from "./Admin/MemberMangement/RoleManagement";
import RoleEditPage from "./Admin/MemberMangement/RoleEditpage";
import NotificationManagement from "./Admin/MemberMangement/AdminNotification";
// import AdminSubscription from "./Admin/AdminSubscription";
// import SettingsMenu from "./Admin/Settings";
import CategoryManagementPage from "./Admin/ArticleMangement/CategoryManagementPage";
import SubCategoryManagementPage from "./Admin/ArticleMangement/SubCategoryManagementPage";
// import SettingsManagement from "./Admin/Settings/Settings";
import SettingsManagement from "./Admin/Settings/AdminSettings";
import SubscriptionManagement from "./Admin/MemberMangement/SubscriptionManagement";
import CommentsPage from "./Admin/ArticleMangement/CommentsManagement";
import AdminGenealoyTree from "./DashboardFiles/Network/AdminGenealoyTree";
import EditProfile from "./DashboardFiles/EditProfile";
import ScrollToTop from "./ScrollTopPage";
import PageNotFound from "./Pages/Home/PageNotFound";
import AdminEwallet from "./Admin/Ewallet/AdminEwallet";
import AdminPayout from "./Admin/Ewallet/AdminPayout";
import HomePageSetting from "./Admin/ArticleMangement/AdminArticleSetting";
import HighlightsSetting from "./Admin/ArticleMangement/AdminHighlightSetting";
import AddHighlight from "./Admin/ArticleMangement/AddHighlight";
import EditHighlight from "./Admin/ArticleMangement/EditHighlight";
import EditArticleSetting from "./Admin/ArticleMangement/EditArticlesetting";

const Layout = () => {
    const location = useLocation();

    // List of authentication routes
    const authRoutes = ["/login", "/register", "/verify", "/forget-password", "/restpassword", "/forget-verify", "/subscription", "/signup", "/signup-form", "/invitefriends" ];

    // Check if the current path is an authentication route
    const isAuthRoute = authRoutes.includes(location.pathname);

    const userType = sessionStorage.getItem("user_type");

    return (
        <>
            {!isAuthRoute && <Navbar2 />}
            <ScrollToTop />
            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Hero />} />
                <Route path="detail/:id" element={<DemoDetail />} />
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Member_Register />} />
                <Route path="verify" element={<Member_Verify />} />
                <Route path="forget-password" element={<ForgetPassword />} />
                <Route path="restpassword" element={<Restpassword />} />
                <Route path="forget-verify" element={<Forget_verify />} />
                <Route path="/home" element={<Hero />} />
                <Route path="/category/:id" element={<ArticlesByCat />} />
                <Route path="/subcategory/:id" element={<ArticlesBySubCat />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/signup-form" element={<SignUpForm />} />
                <Route path="/invitefriends" element={<InviteFriends />} />


                <Route path="*" element={<PageNotFound />} />

                {/* User Dashboard Protected Routes */}

                {userType == 3 && (
                    <Route path="/" element={<MemberLayout />}>
                        <Route path="dashboard" element={<DashboardHome />} />
                        <Route path="downline" element={<DownlineMembers />} />
                        <Route path="genealogy" element={<GenealogyTree />} />
                        <Route path="ewallet" element={<EInfo />} />
                        <Route path="payout" element={<Payout />} />
                        <Route path="addmember" element={<AddMember />} />
                        <Route path="editmember/:id" element={<EditMember />} />
                        <Route path="profile" element={<UserProfile />} />
                        <Route path="editprofile" element={<EditProfile />} />
                        <Route path="subscription" element={<Subscription />} />
                        <Route path="settings" element={<MemberSettings />} />
                        <Route path="invite-topline" element={<InviteTopline />} />
                    </Route>
                )}

                {/* Admin Dashboard Protected Routes */}
                {userType == 1 && (
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route path="admin-profile" element={<AdminProfile />} />
                        <Route path="admin-edit-profile" element={<AdminEditProfile />} />
                        <Route path="admin-dashboard" element={<AdminDashboard />} />
                        <Route path="rss-management" element={<RssPost />} />
                        <Route path="add-rsspost" element={<AddRss />} />
                        <Route path="edit-rsspost/:id" element={<EditRss />} />
                        <Route path="magazine-management" element={<MagazineManagement />} />
                        <Route path="add-magazine" element={<AddMagazine />} />
                        <Route path="edit-magazine/:id" element={<EditMagazine />} />
                        <Route path="article-management" element={<MultimediaManagement />} />
                        {/* <Route path="multimedia" element={<MultimediaManagement />} /> */}
                        <Route path="user-management" element={<UserManagement />} />
                        <Route path="admin-reports" element={<AdminReports />} />
                        <Route path="add-post" element={<AddPost />} />
                        <Route path="edit-post/:id" element={<EditPost />} />
                        <Route path="ad-management" element={<AdManagement />} />
                        <Route path="user/adduser" element={<AdminUserAdd />} />
                        <Route path="user/edit/:id" element={<EditUserPage />} />
                        <Route path="role-management" element={<RoleManagement />} />
                        <Route path="edit-role/:id" element={<RoleEditPage />} />
                        <Route path="notification-management" element={<NotificationManagement />} />
                        <Route path="category-management" element={<CategoryManagementPage />} />
                        <Route path="sub-category-management" element={<SubCategoryManagementPage />} />
                        <Route path="settings" element={<SettingsManagement />} />
                        <Route path="subscription" element={<SubscriptionManagement />} />
                        <Route path="comments-management" element={<CommentsPage />} />
                        <Route path="genealogy-tree" element={<AdminGenealoyTree />} />

                        <Route path="admin-ewallet" element={<AdminEwallet />} />
                        <Route path="admin-payout" element={<AdminPayout />} />
                        <Route path="homepage-settings" element={<HomePageSetting />} />
                        <Route path="highlight-settings" element={<HighlightsSetting />} />
                        <Route path="add-highlight" element={<AddHighlight />} />
                        <Route path="edit-highlight/:id" element={<EditHighlight />} />
                        <Route path="edit-articlesettings/:id" element={<EditArticleSetting />} />
                    </Route>
                )}
            </Routes>
            {!isAuthRoute && <Footer />}
        </>
    );
};

const Router = () => (
    <BrowserRouter basename="">
        <Layout />
    </BrowserRouter>
);

export default Router;
